import styled from "styled-components";
import { useLocale } from "../../../../hooks/useLocale";
import { Heading6 } from "../../../../components/typography/Heading6";
import { theme } from "../../../../themes/theme";
import { Button, ButtonVariant } from "../../../../components/button/Button";
import { Dialog } from "@mui/material";

type TermsAndConditionsDialogProps = {
  open: boolean;
  onAccept: () => Promise<void>;
  onCancel: () => void;
};

export const TermsAndConditionsDialog = ({
  open,
  onAccept,
  onCancel,
}: TermsAndConditionsDialogProps) => {
  const loc = useLocale("homePage.termsAndConditionsDialog");

  return (
    <Dialog open={open}>
      <Root>
        <Heading6>{loc("title")}</Heading6>
        <p>
          {loc("description")}{" "}
          <a href={loc("link")} target="_blank" rel="noreferrer">
            {loc("linkText")}
          </a>
        </p>
        <Actions>
          <Button variant="text" onClick={onCancel}>
            {loc("actions.cancel")}
          </Button>
          <Button buttonVariant={ButtonVariant.primary} onClick={onAccept}>
            {loc("actions.confirm")}
          </Button>
        </Actions>
      </Root>
    </Dialog>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.l};
  padding: ${theme.spacing.l} ${theme.spacing.lxx};
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.m};
  margin-top: ${theme.spacing.l};
`;
